<template>
  <section class="section player-info">
    <div class="error-container">
      <img class="chicken" src="../assets/img/chicken.png" alt="chicken" />
      <div class="error">
        <h3 class="error-heading">
          Wystąpił <span class="text-accent">błąd</span>
        </h3>
        <p class="error-msg">
          {{ error }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Error",
  props: ["error"]
};
</script>
